import React from "react";
import { useHistory } from "react-router-dom";
import { Row, Col, Card, CardTitle, CardBody, CardFooter } from "reactstrap";

import { ROTA_LOTES } from "../../../Trackfy/DespachoIndicadores/regras";
import useResumoDespacho from "./useResumoDespacho";
import "../indicadoresLinha.css";

// KPIs de despacho da aba "Despacho" da Torre (PO1-3494, épico PO1-3493).
//
// Espelha o `componentsPerformance/IndicadoresEntrega` — mesmo formato de card,
// mesmo contrato `deferLoad`/`onRegisterFetch`. O dado vem do resumo compartilhado
// (useResumoDespacho): uma chamada para a aba inteira.
//
// Drill-down cai no MESMO recorte do card (período + etapa) na tela
// Trackfy › Indicadores › Despacho, senão o número da lista não bate com o do
// indicador.

export const ROTA_INDICADORES = "/app/trackfy/indicadores/despacho";

const fmtNumero = (v) => (v === null || v === undefined ? "-" : Number(v).toLocaleString("pt-BR"));

const fmtPercent = (v) =>
  v === null || v === undefined
    ? "-"
    : `${(Number(v) * 100).toLocaleString("pt-BR", { minimumFractionDigits: 1, maximumFractionDigits: 1 })}%`;

export function linkIndicadores(periodo, etapa) {
  const filtro = etapa ? `&etapa=${etapa}` : "";
  return `${ROTA_INDICADORES}?de=${encodeURIComponent(periodo.de)}&ate=${encodeURIComponent(periodo.ate)}${filtro}`;
}

export function montarCards(resumo, periodo) {
  if (!resumo) return [];
  const { etiquetas, lotes, coletas } = resumo;
  return [
    {
      titulo: "Etiquetas emitidas",
      valor: fmtNumero(etiquetas.emitidas),
      subtitulo: `${fmtNumero(etiquetas.emProcessamento)} em processamento · ${fmtNumero(etiquetas.canceladas)} cancelada(s)`,
      icone: "tim-icons icon-tag",
      tom: "icon-primary",
      link: linkIndicadores(periodo, null),
    },
    {
      titulo: "Com falha",
      valor: fmtNumero(etiquetas.falhas),
      subtitulo: "Etiquetas recusadas pela transportadora",
      icone: "tim-icons icon-alert-circle-exc",
      tom: "icon-danger",
      link: linkIndicadores(periodo, "falha"),
    },
    {
      titulo: "Taxa de falha",
      valor: fmtPercent(etiquetas.taxaFalha),
      subtitulo: "Falhas sobre o total de pedidos de etiqueta",
      icone: "tim-icons icon-chart-bar-32",
      tom: "icon-warning",
    },
    {
      titulo: "Lotes despachados",
      valor: fmtNumero(lotes.despachados),
      subtitulo: `${fmtNumero(lotes.abertos)} aberto(s) · ${fmtNumero(lotes.fechadosSemDespacho)} fechado(s) sem despacho`,
      icone: "tim-icons icon-send",
      tom: "icon-success",
      link: `${ROTA_LOTES}?aba=despachado`,
    },
    {
      titulo: "Coletas solicitadas",
      valor: fmtNumero(coletas.solicitadas),
      subtitulo: `${fmtNumero(coletas.falhas)} com falha · ${fmtNumero(coletas.despachadosSemColeta)} despachado(s) sem coleta`,
      icone: "tim-icons icon-delivery-fast",
      tom: "icon-info",
    },
  ];
}

export default function IndicadoresDespacho({ deferLoad = false, onRegisterFetch }) {
  const { dados, periodo } = useResumoDespacho({ deferLoad, onRegisterFetch });
  const history = useHistory();
  const indicadores = montarCards(dados, periodo);

  return (
    <Row className="indicadores-linha">
      {indicadores.map((indicador) => (
        <Col lg md="6" key={indicador.titulo}>
          <Card
            style={{
              boxShadow: "0px 1px 20px 0px rgb(0, 0, 0)", // theme-ok: mesma sombra dos demais cards de indicador
              cursor: indicador.link ? "pointer" : "default",
            }}
            className="card-stats"
            onClick={indicador.link ? () => history.push(indicador.link) : undefined}
          >
            <CardBody>
              <Row>
                <Col xs="4">
                  <div className={`info-icon text-center ${indicador.tom}`}>
                    <i className={indicador.icone} />
                  </div>
                </Col>
                <Col xs="8">
                  <div className="numbers">
                    <CardTitle tag="h4">{indicador.titulo}</CardTitle>
                    <CardTitle tag="h3">{indicador.valor}</CardTitle>
                  </div>
                </Col>
              </Row>
            </CardBody>
            <CardFooter>
              <hr />
              <div className="stats" style={{ display: "flex", alignItems: "center", gap: 6 }}>
                <i className="tim-icons icon-sound-wave" />
                {indicador.subtitulo}
              </div>
            </CardFooter>
          </Card>
        </Col>
      ))}
    </Row>
  );
}
